import {PIXI} from '@colonist/pixi'
import {UIGameKnightController} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGameKnightController'
import {UIGamePlayerInformationKnightView} from '../../../../shared/scripts/ui_game/ui_game_cities_and_knights/UIGamePlayerInformationKnightView'
import {UIWGamePlayerInformationKnightView} from './UIWGamePlayerInformationKnightView'
import {UIGameManager} from '../../../../shared/scripts/ui_game/UIGameManager'
import {UIGameActionButtonMultiView} from '../../../../shared/scripts/ui_game/ui_game_actions/UIGameActionButtonMultiView'
import {UIWGameActionButtonMultiView} from '../ui_game_action/UIWGameActionButtonMultiView'
import {MechanicValidatorKnightPlayer} from '@colonist/game-mechanic-validators'
import {MechanicKnightState, MechanicPirateState, MechanicRobberState} from '@colonist/game-states'

export class UIWGameKnightController extends UIGameKnightController {
    constructor(uiGameManager: UIGameManager, knightState: MechanicKnightState, robberState: MechanicRobberState | undefined, pirateState: MechanicPirateState | undefined) {
        super(uiGameManager, knightState, robberState, pirateState)

        this.initKnightButton()
    }

    protected createPlayerInformationKnightView(knightPlayerValidator: MechanicValidatorKnightPlayer): UIGamePlayerInformationKnightView {
        return new UIWGamePlayerInformationKnightView(this.uiGameManager, knightPlayerValidator)
    }

    protected createButtonMultiView(preferredPosition: number, buttonContainer: PIXI.Container): UIGameActionButtonMultiView {
        return new UIWGameActionButtonMultiView(this.uiGameManager, preferredPosition, buttonContainer)
    }
}
